import React from 'react';
import styles from './SystemBar.module.css';

const ITEMS = [
  { text: 'Oak Cliff Tech' },
  { text: '//', amp: true },
  { text: 'Est. MMXXVI' },
  { text: '//', amp: true },
  { text: 'Dallas Co., TX' },
  { text: '//', amp: true },
  { text: 'Status: Coming Soon' },
];

const SystemBar: React.FC = () => (
  <div className={styles.sysbar}>
    {ITEMS.map((item, i) => (
      <span key={i} className={item.amp ? styles.amp : undefined}>
        {item.text}
      </span>
    ))}
  </div>
);

export default SystemBar;
